/* eslint-disable max-len */
import clsx from 'clsx';

type PastWorkIconProps = {
  className?: string;
  color?: string;
};

export const MSAppsIcon = ({
  className,
  color = '#3B3B3B',
}: PastWorkIconProps) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('icon', className)}
      aria-hidden
      focusable="false"
    >
      <path
        d="M17.6 8.46771H21.8011V4.26666H17.6V8.46771ZM11.3 8.46771H15.5V4.26666H11.3V8.46771ZM5 8.46771H9.2V4.26666H5V8.46771ZM17.6 14.7677H21.8011V10.5677H17.6V14.7677ZM11.3 14.7677H15.5V10.5677H11.3V14.7677ZM5 14.7677H9.2V10.5677H5V14.7677ZM17.6 21.0677H21.8011V16.8677H17.6V21.0677ZM11.3 21.0677H15.5V16.8677H11.3V21.0677ZM5 21.0677H9.2V16.8677H5V21.0677Z"
        fill={color}
      />
    </svg>
  );
};
